// services/interactionService.js
import { VideoService } from './VideoService' // Assuming we'll move video logic here later
export const InteractionService = {
  processShowInteraction(ann, { router, playerStore, playbackStore, videoStore, clickStore, audioStore, clipStore, annStore }) {
    // log.info(3,"💟 InteractionService processShowInteraction", ann.type_of, ann.content + " (" + ann.exact_time + " - " + ann.exact_finish + ")")
    
    if (ann.hidden || !ann.visible) {
      return { shouldShow: false }
    }

    if (annStore.isDoneAt(ann.exact_time, ann.id)) {
      return { shouldShow: false }
    }
    // log.info(3,"💟 InteractionService processShowInteraction", ann.type_of, ann.content + " (" + ann.exact_time + " - " + ann.exact_finish + ")")
    // Handle singular interactions
    if (this.isSingularInteraction(ann) || ann.pause) {
      log.info(3,"💟 InteractionService processShowInteraction singular interaction", ann.type_of)
      if (ann.pause || ann.type_of == 'pause') {
        // playerStore.pause("InteractionService processShowInteraction pause")
        if (ann.timer == -1) {
          return { shouldShow: true, action: 'pauseUntilClick', singular: true, ann }
        } else {
          return { shouldShow: true, action: 'startTimedPause', timer: ann.timer, singular: true }
        }
      }
      
      if (ann.type_of === 'video' && ann.content) {
        playerStore.pause("InteractionService processShowInteraction startVideo")
        return { 
          shouldShow: false, 
          action: 'startVideo',
          singular: true,
          processPromise: clipStore.streamById(ann.content).then(() => {
            clickStore.startInteractionClip(ann)
          })
        }
      }
      
      if (ann.type_of === 'audio' && ann.content) {
        playerStore.pause("InteractionService processShowInteraction startAudio")
        return { 
          shouldShow: false,
          action: 'startAudio',
          singular: true,
          processPromise: audioStore.streamById(ann.content).then(() => {
            clickStore.startAudio()
          })
        }
      }

      if (ann.type_of === 'resourceTray') {
        return { shouldShow: true, action: 'showMagicMenu', singular: true, ann }
      }

      if (ann.type_of === 'jump') {
        return { shouldShow: false, action: 'jump', value: ann.click_value, singular: true }
      }

      if (ann.type_of === 'variable') {
        let val = ann.value
        if (!val) {
          try { 
            let data = JSON.parse(ann.data)
            val = data.value
          } catch (e) {
            log.info(3,"Error parsing variable data", e)
          }
        }
        return { shouldShow: false, action: 'setVariable', variable: ann.variable, value: val, singular: true }
      }

      if (ann.type_of === 'switch') {
        log.info(3,"🔎 InteractionService processShowInteraction switch", JSON.stringify(ann))
        if (!videoStore.video.manage) {
          return { 
            shouldShow: false, 
            action: 'videoBranch',
            token: ann.click_value.split("---")[1],
            singular: true
          }
        } else {
          if (annStore.shouldPromptOwnerSwitch(ann)) {
            return {
              shouldShow: false,
              action: 'ownerSwitchPrompt',
              ann: ann,
              singular: true
            }
          }
          return {
            shouldShow: false,
            action: null,
            singular: true
          }
        }
      }

      if (ann.type_of === 'back') {
        if (!videoStore.video.manage) {
          return { 
            shouldShow: false, 
            action: 'back',
            singular: true
          }
        } else {
          // Show temproary message to owner indicating skip
          return {
            shouldShow: false,
            action: null,
            message: "skipped_video_branch_as_owner",
            singular: true
          }
        }
      }

      if (ann.type_of === 'reset_viewer') {
        if (!videoStore.video.manage) {
          return {
            shouldShow: false,
            action: 'reset_viewer',
            singular: true
          }
        } else {
          // Show temproary message to owner indicating skip
          return { 
            shouldShow: false, 
            singular: true
          }
        }
      }

      if (ann.type_of === 'reset_interactions') {
        if (!videoStore.video.manage) {
          return {
            shouldShow: false,
            action: 'reset_interactions',
            singular: true
          }
        } else {
          // Show temproary message to owner indicating skip
          return { 
            shouldShow: false, 
            singular: true
          }
        }
      }

      if (ann.type_of === 'chatGPT') {
        return { shouldShow: false, action: 'chatGPT', singular: true }
      }

      if (ann.type_of === 'redirect') {
        if (!videoStore.video.manage) {
          return { 
            shouldShow: false, 
            action: 'redirect',
            target: ann.transformed_click_value || ann.click_value,
            singular: true
          }
        } else {
          // Show temproary message to owner indicating skip
          return {
            shouldShow: false,
            action: null,
            message: "skipped_redirect_as_owner",
            singular: true
          }
        }
      }

      // Add other singular interaction types...
    }

    // Regular interactions (buttons, hotspots, etc)
    // log.info(3,"💟 InteractionService processShowInteraction regular interaction", ann.type_of)
    return { shouldShow: true, singular: false }
  },

  isSingularInteraction(ann) {
    if (!ann) { 
      return false
    }
    return ['video', 'audio', 'jump', 'question', 'pause', 'variable', 'redirect', 
            'switch', 'back', 'resourceTray', 'reset_viewer', 'reset_interactions', 'chatGPT', 'drawing'].includes(ann.type_of)
  }
}
